export default __webpack_public_path__ + "static/media/img_calendar.61b673c6.png";